import data from "../data";
import tippy from "tippy.js";

export default function setupTooltips(objects) {
  const getTooltipContent = (data) => `
    <div class="tooltip__content">
      <h3 class="tooltip__title">${data.title}</h3>
      <div class="tooltip__category">${data.category}</div>
      <div class="tooltip__address">
        <p class="tooltip__address-text">${data.address}</p>
        <a class="tooltip__address-link" href="${data.map}" target="_blank" rel="noopener" title="Show map"></a>
      </div>
      <a class="tooltip__link-site" href="${data.website}" target="_blank" rel="noopener">Visit Website</a>
    </div>`;

  const makeTooltip = (data) => {
    let content = "";

    if (Array.isArray(data)) {
      data.forEach((business) => {
        content += getTooltipContent(business);
      });
    } else {
      content = getTooltipContent(data);
    }

    return `
      <div class="tooltip">
        ${content}
      </div>`;
  };

  objects.forEach((object) => {
    const objectID = object.id.substring(0, object.id.length - 4); // removes -bld suffix
    const objectData = data[objectID] || data.default;

    tippy(object, {
      content: makeTooltip(objectData),
      theme: "light",
      trigger: "click",
      allowHTML: true,
      interactive: true,
      appendTo: document.body,
    });
  });
}
